const $header = document.querySelector('[data-role=header]');
let timeoutId: ReturnType<typeof setTimeout>;


export const toggleScrolledHeader = () => {
	$header?.classList?.add('scrolled');

	clearTimeout(timeoutId);

	timeoutId = setTimeout(() => {
		$header?.classList?.remove('scrolled');
	}, 100);
}; 